import { LazyQueryResultTuple, useLazyQuery } from '@apollo/client'
import { GovernmentJobTitlesByHiringOfficeIdQuery, GovernmentJobTitlesByHiringOfficeIdQueryVariables } from '../../../types'
import { GET_GOVERNMENT_JOB_TITLES_BY_HIRING_OFFICE_ID } from '../Queries'

export const useGovernmentJobTitlesByHiringOfficeId = (): LazyQueryResultTuple<
  GovernmentJobTitlesByHiringOfficeIdQuery,
  GovernmentJobTitlesByHiringOfficeIdQueryVariables
> => {
  return useLazyQuery<GovernmentJobTitlesByHiringOfficeIdQuery, GovernmentJobTitlesByHiringOfficeIdQueryVariables>(
    GET_GOVERNMENT_JOB_TITLES_BY_HIRING_OFFICE_ID,
    {
      fetchPolicy: 'network-only',
    },
  )
}
